import api from './api'
import type {
  SlackAuthInitResponse,
  SlackConnectionStatusResponse,
  SlackConnectionSuccessResponse,
  SlackAuthCallbackRequest,
} from '@/schemas/slack-integration'
import type { AxiosRequestConfig } from 'axios'

export const slackIntegrationService = {
  /**
   * Initiate Slack OAuth flow
   * Returns the auth URL to redirect the user to Slack consent screen
   */
  async initiateAuth(
    orgId: string,
    config?: AxiosRequestConfig
  ): Promise<SlackAuthInitResponse> {
    const response = await api.post<SlackAuthInitResponse>(
      `/organizations/${orgId}/integrations/slack/auth`,
      {},
      config
    )
    return response.data
  },

  /**
   * Handle Slack OAuth callback
   * Exchanges the authorization code for a bot token and creates the connection
   */
  async handleCallback(
    orgId: string,
    data: SlackAuthCallbackRequest,
    config?: AxiosRequestConfig
  ): Promise<SlackConnectionSuccessResponse> {
    const response = await api.post<SlackConnectionSuccessResponse>(
      `/organizations/${orgId}/integrations/slack/callback`,
      data,
      config
    )
    return response.data
  },

  /**
   * Get Slack connection status for an organization
   */
  async getStatus(
    orgId: string,
    config?: AxiosRequestConfig
  ): Promise<SlackConnectionStatusResponse> {
    const response = await api.get<SlackConnectionStatusResponse>(
      `/organizations/${orgId}/integrations/slack/status`,
      config
    )
    return response.data
  },

  /**
   * Disconnect Slack account from organization
   */
  async disconnect(orgId: string, config?: AxiosRequestConfig): Promise<void> {
    await api.delete(`/organizations/${orgId}/integrations/slack`, config)
  },
}
